import { useMutation, useQueryClient } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODVideo } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestDeleteVOD = () => {
  const queryClient = useQueryClient();
  return useMutation<IVODVideo, IErrorResponse, string>({
    mutationFn: async (videoId: string) => {
      const response = await requestReactQuery<IVODVideo>({
        url: routeReplacer(VIDEO_INTEGRATION_SERVICE_URLS.VOD_DELETE_VIDEO, {
          videoId,
        }),
        config: { method: 'DELETE' },
      });
      queryClient.invalidateQueries(REQUEST_ACTIONS.GET_VOD_VIDEOS);
      return response;
    },
  });
};
